export const SHOP_PREFIX = '@@shop';

/* Get Shop Info  */
export const GET_SHOP_INFO = '@@shop/GET_SHOP_INFO';
export const GET_SHOP_INFO_FULFILLED = '@@shop/GET_SHOP_INFO_FULFILLED';
export const GET_SHOP_INFO_CANCELLED = '@@shop/GET_SHOP_INFO_CANCELLED';
export const GET_SHOP_INFO_REJECTED = '@@shop/GET_SHOP_INFO_REJECTED';

/* Get Shop Address  */
export const GET_SHOP_ADDRESS = SHOP_PREFIX + '/GET_SHOP_ADDRESS';
export const GET_SHOP_ADDRESS_FULFILLED = SHOP_PREFIX + '/GET_SHOP_ADDRESS_FULFILLED';
export const GET_SHOP_ADDRESS_CANCELLED = SHOP_PREFIX + '/GET_SHOP_ADDRESS_CANCELLED';
export const GET_SHOP_ADDRESS_REJECTED = SHOP_PREFIX + '/GET_SHOP_ADDRESS_REJECTED';

/* Get Shop Address  */
export const GET_SHOP_DESCRIPTION = SHOP_PREFIX + '/GET_SHOP_DESCRIPTION';
export const GET_SHOP_DESCRIPTION_FULFILLED = SHOP_PREFIX + '/GET_SHOP_DESCRIPTION_FULFILLED';
export const GET_SHOP_DESCRIPTION_CANCELLED = SHOP_PREFIX + '/GET_SHOP_DESCRIPTION_CANCELLED';
export const GET_SHOP_DESCRIPTION_REJECTED = SHOP_PREFIX + '/GET_SHOP_DESCRIPTION_REJECTED';